import Siema from '../../../js/vendor/siema';
import marker from './location.png';
import markerHover from './location_hover.png';

export class mapLocation {
  constructor() {
    this.slider = null;
  }

  static createMobileOverview( region, list, lang, chart ) {
    let map = document.querySelector( '.map' );
    let locationList = document.createElement( 'div' );
    let continentName = '';
    let locationTranslation = lang.translations.locations;

    for ( let continent of lang.continents ) {
      if ( continent.name.replace( ' ', '-' ).toLowerCase() === region ) {
        continentName = continent.translation;
      }
    }

    if ( list.length === 1 ) {
      locationTranslation = lang.translations.location;
    }

    if ( map.querySelector( '.map__location-list-container--world' ) === null && region === 'world' ) {
      locationList.classList.add( 'map__location-list-container' );
      locationList.classList.add( 'map__location-list-container--world' );
      locationList.id = 'map-location-list-world';

      locationList.innerHTML = `<div class="map__location-list-detail-container" id="map-location-list-detail">
                <div class="map__location-list-image-container"><img class="map__location-list-image" src="${ marker }"></div>
                <div class="map__location-list-detail-content-container">
                    <p><strong>${continentName}</strong>${list.length} ${locationTranslation}</p>
                </div>
            </div>
            <div class="map__location-list-link-container" id="map-location-list-link-world"></div>`;

      map.appendChild( locationList );
      this.fillLocationLinkListWorld( list, 'map-location-list-link-world', chart );
    }

    if ( map.querySelector( '.map__location-list-container--continent' ) === null && region !== 'world' ) {
      locationList.classList.add( 'map__location-list-container' );
      locationList.classList.add( 'map__location-list-container--continent' );
      locationList.id = 'map-location-list-continent';

      locationList.innerHTML = `<div class="map__location-list-back-button-container map__location-list-back-button-container--hidden"><a class="link map__location-list-back-button" id="map-location-list-back">${lang.translations.back}</a></div>
            <div class="map__location-list-detail-container" id="map-location-list-detail">
                <div class="map__location-list-image-container"><img class="map__location-list-image" src="${ marker }"></div>
                <div class="map__location-list-detail-content-container">
                    <p><strong>${continentName}</strong>${list.length} ${locationTranslation}</p>
                </div>
            </div>
            <div class="map__location-list-link-container" id="map-location-list-link-continent"></div>`;

      map.appendChild( locationList );
      this.fillLocationLinkListContinent( list, 'map-location-list-link-continent', chart );
    }
  }


  static addPagination( current, array ) {
    let paginationList = '';

    for ( let i = 0; i < array.length; i++ ) {
      if ( current.x === array[ i ].x && current.y === array[ i ].y ) {
        paginationList = paginationList + `<li class="pager__item pager__item--link pager__item--active" id="pager-item-${i + 1}" data-pos="${i}">
            <span class="pager__link">${i + 1}</span>
        </li>`;
      } else {
        paginationList = paginationList + `<li class="pager__item pager__item--link" id="pager-item-${i + 1}" data-pos="${i}">
            <span class="pager__link">${i + 1}</span>
        </li>`;
      }
    }
    let paginationString = `<nav class="pager" role="navigation" aria-labelledby="pagination-heading">
        <ul class="pager__items" id="pagination-items" data-amount="${array.length}">
        <li class="pager__item pager__item--prev" id="pager-item-prev"></li>
        <li class="pager__item pager__item-dot pager__item-dot--prev" id="pager-dot-prev"><span class="pager__dots">...</span></li>
        ${paginationList}
        <li class="pager__item pager__item-dot pager__item-dot--next" id="pager-dot-next"><span class="pager__dots">...</span></li>
        <li class="pager__item pager__item--next" id="pager-item-next"></li>
        </ul>
        </nav>`;
    return paginationString;
  }

  static addLogicToPagination( array, chart ) {
    let pagination = document.getElementById( 'pagination-items' );
    let paginationLinks = pagination.querySelectorAll( '.pager__item--link' );
    let prev = document.getElementById( 'pager-item-prev' );
    let next = document.getElementById( 'pager-item-next' );
    let prevDot = document.getElementById( 'pager-dot-prev' );
    let nextDot = document.getElementById( 'pager-dot-next' );

    prev.addEventListener( 'click', () => {
      for ( let i = 0; i < pagination.children.length; i++ ) {
        if ( pagination.children[ i ].classList.contains( 'pager__item--active' )) {
          pagination.children[ i ].classList.remove( 'pager__item--active' );
          pagination.children[ i - 1 ].classList.add( 'pager__item--active' );
          this.locationChangeData( array[ parseInt( pagination.children[ i - 1 ].getAttribute( 'data-pos' )) ], chart );
        }
      }
      this.paginationCheckNextPrev( pagination, prev, next );
      this.paginationCheckDots( paginationLinks, prevDot, nextDot );
    });

    next.addEventListener( 'click', () => {
      for ( let i = 0; i < pagination.children.length; i++ ) {
        if ( pagination.children[ i ].classList.contains( 'pager__item--active' )) {
          pagination.children[ i ].classList.remove( 'pager__item--active' );
          pagination.children[ i + 1 ].classList.add( 'pager__item--active' );
          this.locationChangeData( array[ parseInt( pagination.children[ i + 1 ].getAttribute( 'data-pos' )) ], chart );
          break;
        }
      }
      this.paginationCheckNextPrev( pagination, prev, next );
      this.paginationCheckDots( paginationLinks, prevDot, nextDot );
    });

    for ( let link of paginationLinks ) {
      link.addEventListener( 'click', () => {
        document.getElementsByClassName( 'pager__item--active' )[ 0 ].classList.remove( 'pager__item--active' );
        link.classList.add( 'pager__item--active' );
        this.locationChangeData( array[ parseInt( link.getAttribute( 'data-pos' )) ], chart );
        this.paginationCheckNextPrev( pagination, prev, next );
        this.paginationCheckDots( paginationLinks, prevDot, nextDot );
      });
    }

    if ( pagination.children[ 2 ].classList.contains( 'pager__item--active' )) {
      prev.classList.add( 'pager__item--hidden' );
    } else if ( pagination.children[ pagination.children.length - 3 ].classList.contains( 'pager__item--active' )) {
      next.classList.add( 'pager__item--hidden' );
    }

    if ( paginationLinks.length <= 5 ) {
      let dots = document.querySelectorAll( '.pager__item-dot' );
      for ( let dot of dots ) {
        dot.classList.add( 'pager__item-dot--hidden' );
      }
    } else {
      this.paginationCheckDots( paginationLinks, prevDot, nextDot );
    }
  }

  static paginationCheckNextPrev( pagination, prev, next ) {
    if ( pagination.children[ 2 ].classList.contains( 'pager__item--active' )) {
      prev.classList.add( 'pager__item--hidden' );
      if ( next.classList.contains( 'pager__item--hidden' )) {
        next.classList.remove( 'pager__item--hidden' );
      }
    } else if ( pagination.children[ pagination.children.length - 3 ].classList.contains( 'pager__item--active' )) {
      next.classList.add( 'pager__item--hidden' );
      if ( prev.classList.contains( 'pager__item--hidden' )) {
        prev.classList.remove( 'pager__item--hidden' );
      }
    } else {
      if ( next.classList.contains( 'pager__item--hidden' )) {
        next.classList.remove( 'pager__item--hidden' );
      }
      if ( prev.classList.contains( 'pager__item--hidden' )) {
        prev.classList.remove( 'pager__item--hidden' );
      }
    }
  }

  static paginationCheckDots( paginationLinks, prevDot, nextDot ) {
    for ( let i = 0; i < paginationLinks.length; i++ ) {

      let active = parseInt( document.getElementsByClassName( 'pager__item--active' )[ 0 ].getAttribute( 'data-pos' ));

      if ( active < 3 && i < 3 && !prevDot.classList.contains( 'pager__item-dot--hidden' )) {
        prevDot.classList.add( 'pager__item-dot--hidden' );
      } else if ( active >= 3 && i >= 3 && prevDot.classList.contains( 'pager__item-dot--hidden' ) && paginationLinks.length > 5 ) {
        prevDot.classList.remove( 'pager__item-dot--hidden' );
      }

      if ( active > paginationLinks.length - 4 && i > paginationLinks.length - 4 && !nextDot.classList.contains( 'pager__item-dot--hidden' )) {
        nextDot.classList.add( 'pager__item-dot--hidden' );
      } else if ( active <= paginationLinks.length - 4 && i <= paginationLinks.length - 4 && nextDot.classList.contains( 'pager__item-dot--hidden' ) && paginationLinks.length > 5 ) {
        nextDot.classList.remove( 'pager__item-dot--hidden' );
      }

      if (( active === 0 || active === 1 || active === 2 ) && i >= 5 && !paginationLinks[ i ].classList.contains( 'pager__item--link-hidden' )) {
        paginationLinks[ i ].classList.add( 'pager__item--link-hidden' );
      } else if (( active === 0 || active === 1 || active === 2 ) && i < 5 && paginationLinks[ i ].classList.contains( 'pager__item--link-hidden' )) {
        paginationLinks[ i ].classList.remove( 'pager__item--link-hidden' );
      } else if (( active === paginationLinks.length - 1 || active === paginationLinks.length - 2 || active === paginationLinks.length - 3 ) && i > paginationLinks.length - 6 && paginationLinks[ i ].classList.contains( 'pager__item--link-hidden' )) {
        paginationLinks[ i ].classList.remove( 'pager__item--link-hidden' );
      } else if (( active === paginationLinks.length - 1 || active === paginationLinks.length - 2 || active === paginationLinks.length - 3 ) && i <= paginationLinks.length - 6 && !paginationLinks[ i ].classList.contains( 'pager__item--link-hidden' )) {
        paginationLinks[ i ].classList.add( 'pager__item--link-hidden' );
      } else if (( active >= 3 && active <= paginationLinks.length - 4 ) && ( i < active - 2 || i > active + 2 ) && !paginationLinks[ i ].classList.contains( 'pager__item--link-hidden' )) {
        paginationLinks[ i ].classList.add( 'pager__item--link-hidden' );
      } else if (( active >= 3 && active <= paginationLinks.length - 4 ) && ( i >= active - 2 && i <= active + 2 ) && paginationLinks[ i ].classList.contains( 'pager__item--link-hidden' )) {
        paginationLinks[ i ].classList.remove( 'pager__item--link-hidden' );
      }
    }
  }

  static createButtonTemplate( buttons ) {
    let buttonHTML = '';
    for ( let button of buttons ) {
      if ( button.external === true ) {
        buttonHTML = buttonHTML + `<div class="button-wrapper">
            <a class="button button--${ button.prio }"
                href="${ button.target }"target="_blank">
                ${ button.buttonText }
            </a>
           </div>`;
      } else {
        buttonHTML = buttonHTML + `<div class="button-wrapper">
            <a class="button button--${ button.prio }"
                href="${ button.target }">
                ${ button.buttonText }
            </a>
           </div>`;
      }
    }
    return buttonHTML;
  }

  static locationChangeData( data, chart ) {
    let headlineContainer = document.getElementById( 'map-location-headline' );
    let imageContainer = document.getElementById( 'map-location-image' );
    let contentContainer = document.getElementById( 'map-location-content' );

    let points = chart.series[ 1 ].points;

    for ( let point of points ) {
      if ( point.name === data.name ) {
        point.update({
          isActive: true,
          marker: {
            height: 36,
            symbol: `url(${ markerHover })`,
            width: 30
          }
        });
      } else {
        point.update({
          isActive: false,
          marker: {
            height: 36,
            symbol: `url(${ marker })`,
            width: 30
          }
        });
      }
    }

    headlineContainer.innerHTML = data.name;

    if ( data.img ) {
      imageContainer.src = data.img;
      imageContainer.style.display = 'block';
    } else if ( imageContainer !== null ) {
      imageContainer.style.display = 'none';
    }
    let buttonHTML = '';
    if ( data.buttons ) {
      buttonHTML = this.createButtonTemplate( data.buttons );
    }
    if ( !data.copytext ) {
      data.copytext = '';
    }
    contentContainer.innerHTML = data.copytext + buttonHTML;
  }

  static fillLocationLinkListWorld( list, id, chart ) {
    let linkList = document.getElementById( id );
    let linkString = '<ul class="map__location-list-link-items">';

    for ( let i = 0; i < list.length; i++ ) {
      if ( !linkString.includes( 'data-data="' + list[ i ].name )) {
        if ( i === 0 ) {
          linkString = `<ul class="map__location-list-link-items">
            <li class="map__location-list-link-item"><a class="link map__location-list-link" data-number="${i}" data-data="${list[ i ].name}">${list[ i ].labelName}</a></li>`;
        } else if ( i === list.length - 1 ) {
          linkString = linkString + `<li class="map__location-list-link-item"><a class="link map__location-list-link" data-number="${i}" data-data="${list[ i ].name}">${list[ i ].labelName}</a></li></ul>`;
        } else {
          linkString = linkString + `<li class="map__location-list-link-item"><a class="link map__location-list-link" data-number="${i}" data-data="${list[ i ].name}">${list[ i ].labelName}</a></li>`;
        }
      }
    }

    linkList.innerHTML = linkString;

    linkList.querySelectorAll( '.map__location-list-link-item' ).forEach( function( link ) {
      link.addEventListener( 'click', () => {
        let name = link.children[ 0 ].getAttribute( 'data-data' );
        for ( let data of chart.series[ 1 ].data ) {
          if ( data.name === name ) {
            data.firePointEvent( 'click' );
            document.querySelector( '.map__location-list-container--world' ).classList.toggle( 'map__location-list-container--world-hidden' );
            break;
          }
        }
      });
    });
  }

  static fillLocationLinkListContinent( list, id, chart ) {
    let linkList = document.getElementById( id );
    let linkString = '<ul class="map__location-list-link-items">';

    for ( let i = 0; i < list.length; i++ ) {
      if ( i % 10 === 0 && i === 0 ) {
        linkString = `<ul class="map__location-list-link-items">
            <li class="map__location-list-link-item"><a class="link map__location-list-link" data-number="${i}" data-data="{ name: ${list[ i ].name}}">${list[ i ].name}</a></li>`;
      } else if ( i % 10 === 0 && i !== list.length - 1 ) {
        linkString = linkString + `</ul><ul class="map__location-list-link-items">
            <li class="map__location-list-link-item"><a class="link map__location-list-link" data-number="${i}" data-data="{ name: ${list[ i ].name}}">${list[ i ].name}</a></li>`;
      } else if ( i % 10 === 0 && i === list.length - 1 && i !== 0 ) {
        linkString = linkString + `</ul><ul class="map__location-list-link-items">
            <li class="map__location-list-link-item"><a class="link map__location-list-link" data-number="${i}" data-data="{ name: ${list[ i ].name}}">${list[ i ].name}</a></li></ul>`;
      } else if ( i === list.length - 1 ) {
        linkString = linkString + `<li class="map__location-list-link-item"><a class="link map__location-list-link" data-number="${i}" data-data="{ name: ${list[ i ].name}}">${list[ i ].name}</a></li></ul>`;
      } else {
        linkString = linkString + `<li class="map__location-list-link-item"><a class="link map__location-list-link" data-number="${i}" data-data="{ name: ${list[ i ].name}}">${list[ i ].name}</a></li>`;
      }
    }

    linkList.innerHTML = linkString;

    let linkLists = linkList.querySelectorAll( '.map__location-list-link-items' ).length;
    if ( linkLists > 1 ) {
      this.createLocationListSlider( linkList );
    }

    let backButton = document.querySelector( '.map__location-list-back-button-container' );

    backButton.children[ 0 ].addEventListener( 'click', () => {
      let map = document.querySelector( '.map' );
      let locationContainer = map.querySelector( '.map__location-container' );
      if ( locationContainer !== null ) {
        map.removeChild( locationContainer );
      }
      if ( document.querySelector( '.map__location-list-detail-container--hidden' ) !== null ) {
        backButton.classList.add( 'map__location-list-back-button-container--hidden' );
        document.querySelector( '.map__location-list-detail-container' ).classList.remove( 'map__location-list-detail-container--hidden' );
        document.querySelector( '.map__location-list-link-container' ).classList.remove( 'map__location-list-link-container--hidden' );
        if ( document.querySelector( '.map__location-overview-pagination-container' )) {
          document.querySelector( '.map__location-overview-pagination-container' ).classList.remove( 'map__location-overview-pagination-container--hidden' );
        }
      }
    });

    linkList.querySelectorAll( '.map__location-list-link-item' ).forEach( function( link ) {
      link.addEventListener( 'click', () => {
        let map = document.querySelector( '.map' );
        let pos = parseInt( link.children[ 0 ].getAttribute( 'data-number' ));
        this.createLocationInformation( list[ pos ], list[ pos ], chart );
        if ( document.querySelector( '.map__location-list-back-button-container--hidden' ) !== null ) {
          backButton.classList.remove( 'map__location-list-back-button-container--hidden' );
          document.querySelector( '.map__location-list-detail-container' ).classList.add( 'map__location-list-detail-container--hidden' );
          document.querySelector( '.map__location-list-link-container' ).classList.add( 'map__location-list-link-container--hidden' );
          if ( document.querySelector( '.map__location-overview-pagination-container' )) {
            document.querySelector( '.map__location-overview-pagination-container' ).classList.add( 'map__location-overview-pagination-container--hidden' );
          }
        }

        let container = map.querySelector( '.map__location-container' );
        let anchorPos = container.getBoundingClientRect().top;
        let bodyPos = document.body.getBoundingClientRect().top;
        let headerheight = document.querySelector( '.header' ).offsetHeight;
        let toScroll = ( anchorPos - bodyPos ) - headerheight;
        window.scrollTo({ top: toScroll, behavior: 'smooth' });
      });
    }.bind( this ));
  }

  static createLocationListSlider( lists ) {
    let amount = lists.querySelectorAll( '.map__location-list-link-items' ).length;
    let pagination = '';

    for ( let i = 0; i < amount; i++ ) {
      pagination = pagination + `<div class="map__location-pagination-box" data-index="${i}"></div>`;
    }
    let listPagination = document.createElement( 'div' );
    listPagination.classList.add( 'map__location-overview-pagination-container' );
    listPagination.classList.add( 'content-width' );
    listPagination.innerHTML = pagination;

    document.querySelectorAll( '.map__location-list-container' )[ 1 ].appendChild( listPagination );

    this.slider = new Siema({
      selector: lists,
      loop: true,
      onChange: this.setActivePagination.bind( this )
    });
    this.addSliderPagination();
    this.setActivePagination();
  }

  static addSliderPagination() {
    let paginationBtns = document.querySelectorAll( '.map__location-pagination-box' );
    for ( let paginationBtn of paginationBtns ) {
      paginationBtn.addEventListener( 'click', () => {
        const index = paginationBtn.getAttribute( 'data-index' );
        this.slider.goTo( index );
        this.setActivePagination( index );
      });
    }
  }

  static setActivePagination( index = -1 ) {
    let paginationBtns = document.querySelectorAll( '.map__location-pagination-box' );
    let active = document.querySelector( '.map__location-pagination-box--active' );

    const current = ( index === -1 ) ? this.slider.currentSlide : index;
    if ( active !== null ) {
      active.classList.remove( 'map__location-pagination-box--active' );
    }
    paginationBtns[ current ].classList.add( 'map__location-pagination-box--active' );
  }

  static createLocationInformation( current, all, chart, handleResize ) {
    let map = document.querySelector( '.map' );
    let locationContainer = document.createElement( 'div' );
    let pagination = '';
    let container = map.querySelector( '.map__location-container' );

    if ( all.length > 1 ) {
      pagination = this.addPagination( current, all );
    }

    if ( map.querySelector( '.map__location-container' ) === null ) {
      locationContainer.classList.add( 'map__location-container' );
      locationContainer.id = 'map-location';
      let buttonHTML = '';

      if ( current.buttons ) {
        buttonHTML = this.createButtonTemplate( current.buttons );
      }
      if ( !current.copytext ) {
        current.copytext = '';
      }
      if ( !current.img ) {
        locationContainer.innerHTML = `<div class="map__location-headline-container"><svg class="map__location-close svg-icon"><use xlink:href="#form_pulldown_close"></use></svg><h3 class="map__location-headline" id="map-location-headline">${current.name}</h3></div>
            <div class="map__location-content-container"><div class="map__location-image-container"><img class="map__location-image" id="map-location-image" src="" style="display: none;"></div><div class="map__location-content" id="map-location-content">${current.copytext}${buttonHTML}</div>${pagination}</div>`;
      } else {
        locationContainer.innerHTML = `<div class="map__location-headline-container"><svg class="map__location-close svg-icon"><use xlink:href="#form_pulldown_close"></use></svg><h3 class="map__location-headline" id="map-location-headline">${current.name}</h3></div>
            <div class="map__location-content-container"><div class="map__location-image-container"><img class="map__location-image" id="map-location-image" src="${current.img}"></div><div class="map__location-content" id="map-location-content">${current.copytext}${buttonHTML}</div>${pagination}</div>`;
      }
      locationContainer.classList.add( 'map__location-container--show' );
      map.insertBefore( locationContainer, map.firstChild );
      document.querySelector( '.map__location-close' ).addEventListener( 'click', () => {
        map.removeChild( locationContainer );
        let points = chart.series[ 1 ].points;
        for ( let point of points ) {
          point.update({
            isActive: false,
            marker: {
              height: 36,
              symbol: `url(${ marker })`,
              width: 30
            }
          });
        }
        handleResize();
      });

      if ( all.length > 1 ) {
        this.addLogicToPagination( all, chart );
      }
    } else {
      let buttonHTML = '';

      if ( current.buttons ) {
        buttonHTML = this.createButtonTemplate( current.buttons );
      }
      if ( !current.copytext ) {
        current.copytext = '';
      }
      if ( !current.img ) {
        container.innerHTML = `<div class="map__location-headline-container"><svg class="map__location-close svg-icon"><use xlink:href="#form_pulldown_close"></use></svg><h3 class="map__location-headline" id="map-location-headline">${current.name}</h3></div>
            <div class="map__location-content-container"><div class="map__location-image-container"><img class="map__location-image" id="map-location-image" src="" style="display: none;"></div><div class="map__location-content" id="map-location-content">${current.copytext}${buttonHTML}</div>${pagination}</div>`;
      } else {
        container.innerHTML = `<div class="map__location-headline-container"><svg class="map__location-close svg-icon"><use xlink:href="#form_pulldown_close"></use></svg><h3 class="map__location-headline" id="map-location-headline">${current.name}</h3></div>
            <div class="map__location-content-container"><div class="map__location-image-container"><img class="map__location-image" id="map-location-image" src="${current.img}"></div><div class="map__location-content" id="map-location-content">${current.copytext}${buttonHTML}</div>${pagination}</div>`;
      }
      setTimeout(() => {
        container.classList.add( 'map__location-container--show' );
      }, 300 );
      document.querySelector( '.map__location-close' ).addEventListener( 'click', () => {
        map.removeChild( container );
        let points = chart.series[ 1 ].points;
        for ( let point of points ) {
          point.update({
            isActive: false,
            marker: {
              height: 36,
              symbol: `url(${ marker })`,
              width: 30
            }
          });
        }
        handleResize();
      });

      if ( all.length > 1 ) {
        this.addLogicToPagination( all, chart );
      }
    }
  }
}
